<template>
    <div>
        <div class="white-box mt-3">
            <div class="data-group">
                <M3FormTitle title="Împuternicit" :checked="completed"></M3FormTitle>
                <div class="warn">
                    <p>ATENȚIE!</p>
                    <p>Persoana desemnată ca reprezentant legal va semna toate documentele generate și va reprezenta compania în relația cu finanțatorul.</p>
                </div>
                <div v-if="getAssociates" class="select-person flex space-between">
                    <div class="alege-asociat flex space-between">
                        <p>Alege dintre asociați</p>
                        <v-select
                            v-model="asociatSelectat"
                            class="w-96"
                            dir="ltr"
                            :options="getAssociates"
                            label="name"
                            input-id="id_series"
                            :clearable="false"
                            :class="completed ? 'disabled-select' : '' "
                            @input="selectedAssociateChanged"
                        >
                            <span slot="no-options">
                                Nu există asociați adăugați.
                            </span>
                        </v-select>
                    </div>
                    <div class="yellow-button" @click="clearAssociate()">
                        Adaugă o persoană diferită
                    </div>
                </div>

                <validation-observer #default="{ invalid }" ref="observer">
                    <span class="display-none">{{ invalid }}</span>
                    <b-form>
                        <div class="asociat mt-4">
                            <div class="flex flex-end responsive-redefine mobile-mb">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Nume și prenume"
                                        class="has-icon custom-responsive mobile-mb"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.name"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.name)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="second-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="4"
                                        content-cols-lg="8"
                                        label="Cetățenie"
                                        class="has-icon custom-responsive mobile-mb"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.citizenship"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.citizenship)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div class="flex flex-end responsive-redefine mobile-mb">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Data și locul nașterii"
                                        class="has-icon custom-responsive mobile-mb"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.birthdate_place"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.birthdate_place)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="second-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="4"
                                        class="custom-responsive mobile-mb"
                                        content-cols-lg="8"
                                        label="Sex"
                                    >
                                        <b-form-select
                                            v-model="form.gender"
                                            :options="sexTypes"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            :class="completed ?'disabled-select':''"
                                            @input="$emit('unsavedChanges', !!form.gender)"
                                        >
                                        </b-form-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div class="flex flex-end responsive-redefine mb-3 mobile-mb">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Aport la capital"
                                        class="has-icon custom-responsive mobile-mb"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.capital_contribution"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.capital_contribution)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="second-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="4"
                                        content-cols-lg="8"
                                        label="Capital social"
                                        class="has-icon custom-responsive mobile-mb"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.social_capital"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.social_capital)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div class="flex space-between">
                                <div class="first-input asociati-first-input flex space-between align-center">
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        class="w-68"
                                        style="width: 86%;"
                                    >
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            label-cols-lg="4"
                                            content-cols-lg="8"
                                            label="Cod numeric personal"
                                            class="has-icon custom-responsive mobile-mb"
                                        >
                                            <b-form-input
                                                id="name"
                                                v-model="form.cnp"
                                                type="text"
                                                name="message"
                                                :state="errors.length > 0 ? false : null"
                                                :readonly="completed"
                                                @input="$emit('unsavedChanges', !!form.cnp)"
                                            ></b-form-input>
                                            <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        </b-form-group>

                                    </validation-provider>
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        class="custom-responsive mobile-mb"
                                        label-cols-lg="4"
                                        content-cols-lg="8"
                                        label="Tip ID"
                                        style="width: 30%;"
                                    >
                                        <v-select
                                            v-model="form.id_type"
                                            dir="ltr"
                                            :options="idTypes"
                                            label="text"
                                            :reduce="(option) => option.value"
                                            input-id="id_series"
                                            :clearable="false"
                                            :class="completed ?'disabled-select':''"
                                        ></v-select>
                                    </b-form-group>
                                </div>
                                <div class="flex space-between align-center w-40" style="width: 32%;">
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        class="second-input w-48"
                                        style="width: 50%;"
                                    >
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            class="custom-responsive mobile-mb"
                                            label-cols-lg="4"
                                            content-cols-lg="8"
                                            label="Serie ID"
                                        >
                                            <b-form-input
                                                id="id_series"
                                                v-model="form.id_series"
                                                type="text"
                                                name="id_series"
                                                :state="errors.length > 0 ? false : null"
                                                :readonly="completed"
                                            >
                                            </b-form-input>
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        class="second-input"
                                        style="width: 50%;"
                                    >
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            label-cols-lg="4"
                                            content-cols-lg="8"
                                            label="Nr"
                                            class="has-icon custom-responsive mobile-mb"
                                        >
                                            <b-form-input
                                                id="name"
                                                v-model="form.id_no"
                                                type="text"
                                                name="message"
                                                :state="errors.length > 0 ? false : null"
                                                :readonly="completed"
                                                @input="$emit('unsavedChanges', !!form.id_no)"
                                            ></b-form-input>
                                            <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </b-form-group>
                                    </validation-provider>
                                </div>
                            </div>
                            <div class="flex space-between mt-1 mobile-mb">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input w-58"
                                    style="width: 60%;"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Eliberat de"
                                        class="has-icon custom-responsive mobile-mb"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.id_released_by"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.id_released_by)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>

                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input w-40"
                                    style="width: 35.5%;"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Eliberat la"
                                        class="has-icon custom-responsive mobile-mb"
                                    >
                                        <b-form-datepicker
                                            id="eliberatLa"
                                            v-model="form.id_released_at"
                                            class="w-100"
                                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                            locale="ro"
                                            :max="max"
                                            placeholder="Selectează o dată"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            :class="{ 'completed': completed }"
                                            @input="$emit('unsavedChanges', !!form.id_released_at)"
                                        ></b-form-datepicker>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div class="flex space-between mt-1 mobile-mb">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required|email"
                                    class="first-input asociati-first-input w-58"
                                    style="width: 60%;"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Adresă email"
                                        class="has-icon custom-responsive mobile-mb"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.email"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.email)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required|numeric"
                                    class="first-input asociati-first-input w-40"
                                    name="telefon"
                                    style="width: 35.5%;"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="3"
                                        content-cols-lg="9"
                                        label="Telefon"
                                        class="has-icon custom-responsive mobile-mb"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.phone"
                                            type="number"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.phone)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label="Adresa domiciliu"
                                        class="has-icon smallerLabel custom-responsive mobile-mb nodiv"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.address"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.address)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    class="first-input asociati-first-input"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label="Fax"
                                        class="has-icon smallerLabel custom-responsive mobile-mb nodiv"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.fax"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.fax)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div class="flex calitate-input align-center mb-5 mt-4">
                                <p class="w-100" style="max-width: 150px; margin-right: 8px;">Calitatea:</p>
                                <div class="position-relative">
                                    <b-form-radio-group v-model="form.delegate_type" :options="options" :class="[completed ?'disabled-radio': 'invalid-radio', radioErrorMessage ? 'error-input' : '']" name="radio-validation" @change="radioErrorMessage = false"></b-form-radio-group>
                                    <small v-if="radioErrorMessage" class="text-danger" style="position: absolute;">Acest câmp este necesar</small>
                                </div>
                                <validation-provider
                                    v-if="form.delegate_type === 'alta'"
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        class="has-icon m-0 custom-responsive mobile-mb"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="form.delegate_type_name"
                                            type="text"
                                            name="message"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.delegate_type_name)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    </b-form-group>
                                </validation-provider>
                            </div>

                            <M3FormTitle :title="'Companii în care reprezentantul legal este asociat ( ' + (form.companies.length ? form.companies.length : 0) + ' )'" class="mt-4" :checked="completed"></M3FormTitle>


                            <div v-for="(company, key) in form.companies" :key="key" class="companies">
                                <div class="mb-3 column-res">
                                    <div class="flex flex-end column-responsive mt-4">
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            class="custom-responsive mobile-mb mb-0"
                                            label-cols-lg="3"
                                            content-cols-lg="9"
                                            label="CUI"
                                            style="width:24%"
                                        >
                                            <b-input-group>
                                                <b-form-input
                                                    id="name"
                                                    v-model="company.business_id"
                                                    type="text"
                                                    name="message"
                                                    :readonly="completed"
                                                    @input="$emit('unsavedChanges', !!company.business_id)"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <div class="search-button" @click="searchCompanyAssoc(company.business_id, key)">Caută</div>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                        <validation-provider
                                            #default="{ errors }"
                                            rules="required"
                                            class="first-input asociati-first-input"
                                            style="width: 40%;"
                                        >
                                            <b-form-group
                                                id="fieldset-horizontal"
                                                label-cols-lg="4"
                                                content-cols-lg="8"
                                                label="Nume companie"
                                                class="has-icon custom-responsive mobile-mb mb-0"
                                            >
                                                <b-form-input
                                                    id="name"
                                                    v-model="company.name"
                                                    type="text"
                                                    name="message"
                                                    :state="errors.length > 0 ? false : null"
                                                    :readonly="completed"
                                                    @input="$emit('unsavedChanges', !!company.name)"
                                                ></b-form-input>
                                                <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </b-form-group>
                                        </validation-provider>
                                        <validation-provider
                                            #default="{ errors }"
                                            rules="required"
                                            class="first-input asociati-first-input"
                                            style="width: 40%;"
                                        >
                                            <b-form-group
                                                id="fieldset-horizontal"
                                                label-cols-lg="4"
                                                content-cols-lg="8"
                                                label="Adresa sediu social"
                                                class="has-icon custom-responsive mobile-mb mb-0"
                                            >
                                                <b-form-input
                                                    id="name"
                                                    v-model="company.address"
                                                    type="text"
                                                    name="message"
                                                    :state="errors.length > 0 ? false : null"
                                                    :readonly="completed"
                                                    @input="$emit('unsavedChanges', !!company.address)"
                                                ></b-form-input>
                                                <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </b-form-group>
                                        </validation-provider>
                                    </div>
                                    <b-icon-x font-scale="1.7" class="delete-delegate-company-icon" @click="deleteDelegateCompany(key)"></b-icon-x>
                                    <div class="mt-2 flex column-responsive">
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            class="custom-responsive mobile-mb mb-0 custom-labels flex-end-input"
                                            label-cols-lg="3"
                                            content-cols-lg="9"
                                            label="Funcție"
                                            style="width: 24%;"
                                        >
                                            <b-input-group>
                                                <b-form-input
                                                    id="name"
                                                    v-model="company.function"
                                                    type="text"
                                                    name="message"
                                                    :readonly="completed"
                                                ></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            class="custom-responsive mobile-mb mb-0"
                                            label-cols-lg="4"
                                            content-cols-lg="8"
                                            label="Capital social"
                                            style="width: 40%;"
                                        >
                                            <b-input-group>
                                                <b-form-input
                                                    id="name"
                                                    v-model="company.percentage"
                                                    type="text"
                                                    name="message"
                                                    :readonly="completed"
                                                    style="text-align: center;"
                                                    :class="getClassByPercentage(company.percentage)"
                                                    @keyup="maxCharLimit(company.percentage, key)"
                                                ></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            class="custom-responsive mobile-mb mb-0"
                                            label-cols-lg="4"
                                            content-cols-lg="8"
                                            label="Funcțiune firmă"
                                            style="width: 40%;"
                                        >
                                            <b-input-group>
                                                <b-form-input
                                                    id="name"
                                                    v-model="company.status"
                                                    type="text"
                                                    name="message"
                                                    :class="getClassByStatus(company.status)"
                                                    :readonly="completed"
                                                    style="text-align: center;"
                                                ></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-end mt-0 mb-5">
                                <div class="add-button" @click="addDelegateCompany()">
                                    <p>Adaugă companie nouă</p>
                                    <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
                                </div>
                            </div>
                        </div>
                        <hr class="mt-5">
                        <b-form-checkbox
                            v-model="completed"
                            switch
                            size="lg"
                            class="switch-box mobile-mb"
                            @change="completeForm()"
                        >Informațiile sunt complete și corecte
                        </b-form-checkbox>
                    </b-form>
                </validation-observer>
            </div>
            <img src="@/assets/images/M3/M3Sketch/termenesmall.png" class="termene-icon">
        </div>
    </div>
</template>

<script>
    import { BForm, BFormInput, BFormGroup, BButton, BFormCheckbox, BFormSelect, BIconX, BFormRadio, BFormRadioGroup, BIconPlusCircleFill, BFormDatepicker, BInputGroup, BInputGroupAppend } from 'bootstrap-vue'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    import M3FormTitle from '../M3FormTitle'
    import serii from '@/pages/Aplicatii/M3/M3Sketch/serii'
    import vSelect from "vue-select";
    import vCombobox from "vue-select";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import "vue-select/dist/vue-select.css";

    export default {
        components: {
            BForm,
            BFormInput,
            BFormGroup,
            BButton,
            BFormCheckbox,
            M3FormTitle,
            BFormSelect,
            BIconX,
            BFormRadio,
            BFormRadioGroup,
            BFormDatepicker,
            BIconPlusCircleFill,
            BInputGroupAppend,
            BInputGroup,
            ValidationProvider,
            ValidationObserver,
            vSelect,
            vCombobox
        },

        props: {
            delegate: {},
            associates: [],
            legaturi: [],
            activeCompany: null,
        },

        data() {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th in two months
            const maxDate = new Date(today)
            maxDate.setMonth(maxDate.getMonth())
            maxDate.setDate(maxDate.getDay() + 4)
            return {
                asociatiMap: null,
                completed: false,
                radioErrorMessage: false,
                max: maxDate,
                idTypes: [
                    { value: 'CI', text: 'CI' },
                    { value: 'BI', text: 'BI' },
                    { value: 'PERMIS CONDUCERE', text: 'PERMIS CONDUCERE' },
                    { value: 'PAȘAPORT', text: 'PAȘAPORT' },
                    { value: 'CERTIFICAT DE NAȘTERE', text: 'CERT. DE NAȘTERE' },
                ],
                sexTypes: [
                    { value: 'feminin', text: 'Feminin' },
                    { value: 'masculin', text: 'Masculin' },
                ],
                idSeries: serii,
                asociatSelectat: {},
                form: {
                    name: '',
                    birthdate_place: '',
                    citizenship: '',
                    gender: '',
                    social_capital: '',
                    capital_contribution: '',
                    cnp: '',
                    id_type: '',
                    id_series: '',
                    id_no: '',
                    id_released_by: '',
                    id_released_at: '',
                    phone: this.$store.getters['auth/user'].phone,
                    email: this.$store.getters['auth/user'].email,
                    delegate_type: '',
                    delegate_type_name: '',
                    address: '',
                    fax: '-',
                    companies: []
                },
                options: [
                    { text: 'Administrator', value: 'second' },
                    { text: 'Asociat', value: 'third' },
                    { text: 'Împuternicit', value: 'four' },
                    { text: 'Altă calitate', value: 'alta' },
                ]
            }
        },

        computed: {
            getAssociates() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.asociatiMap = this.associates
                return this.asociatiMap ? this.asociatiMap.map(function(associate) {
                    let asociat = associate;
                    asociat.name = asociat.type == 1 ? asociat.delegate_name : asociat.name
                    delete asociat.delegate_name
                    delete asociat.company_name
                    delete asociat.business_id
                    delete asociat.type

                    return asociat;
                }) : [];
            },
            checks() {
                return this.$store.getters['checks/checks'];
            }
        },
        watch: {
            checks: {
                handler: function() {
                    this.completed = this.checks.companiaMeaReprezentantLegal;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            delegate: {
                handler () {
                    if(this.delegate) {
                        this.form.name = this.delegate.name
                        this.form.birthdate_place = this.delegate.birthdate_place
                        this.form.citizenship = this.delegate.citizenship
                        this.form.gender = this.delegate.gender ? this.delegate.gender : ''
                        this.form.social_capital = this.delegate.social_capital
                        this.form.capital_contribution = this.delegate.capital_contribution
                        this.form.cnp = this.delegate.cnp
                        this.form.fax = this.delegate.fax ? this.delegate.fax : '-'
                        this.form.id_type = this.delegate.id_type
                        this.form.id_series = this.delegate.id_series
                        this.form.id_released_by = this.delegate.id_released_by
                        this.form.id_released_at = this.delegate.id_released_at
                        this.form.id_no = this.delegate.id_no
                        this.form.phone = this.delegate.phone
                        this.form.address = this.delegate.address
                        this.form.email = this.delegate.email
                        this.form.delegate_type = this.delegate.delegate_type !== 'first' ? this.delegate.delegate_type : 'second'
                        this.form.delegate_type_name = this.delegate.delegate_type_name
                        this.form.companies = this.delegate.companies ? this.delegate.companies : []
                    }
                },
                deep: true,
                immediate: true
            },
        },

        mounted() {
            if(this.associates) {
                this.associates.forEach(associate => {
                    if(associate.cnp === this.form.cnp){

                        this.asociatSelectat = associate;
                    }
                })
            }
        },
        methods: {
            getClassByPercentage(percentage){
                if(percentage <= 24) {
                    return ''
                } else if(percentage > 24 && percentage < 50) {
                    return 'yellow-background'
                } else {
                    return 'red-background'
                }
            },
            getClassByStatus(status) {
                if(status === 'ACTIVĂ') {
                    return 'green-background'
                } else{
                    return 'red-background'
                }
            },
            maxCharLimit(input, key){
                if(input > 100) {
                    this.form.companies[key].percentage = 100
                    this.$toast.error('Nu poți introduce un procent mai mare de 100%.')
                }
            },

            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        if(!this.form.delegate_type){
                            this.radioErrorMessage = true
                        }
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        if(!this.form.delegate_type){
                            this.radioErrorMessage = true
                            this.completed = false
                        } else {
                            if(this.completed){
                                this.form.id_series = this.form.id_series.toUpperCase()
                                this.$store.dispatch('m3Sketch/saveAllDataPart', {
                                    delegate: this.form,
                                    delegate_type: this.form.delegate_type == 'alta' ?
                                        this.form.delegate_type_name :
                                        this.options.find((option) => {
                                            return option.value == this.form.delegate_type
                                        }) ? this.options.find((option) => {
                                            return option.value == this.form.delegate_type
                                        }).text : ''
                                }).then((response) => {
                                    this.$emit('associateCompanies', this.form.companies)
                                    this.$toast.success(response.data.message)
                                }).catch((xhr) => {
                                    if (xhr.status === 422) {
                                        this.errors.record(xhr.responseJSON.errors);
                                    }
                                    this.$toast.error(xhr.response.data.message);
                                });
                            }
                        }
                    }
                    if(this.checks.companiaMeaReprezentantLegal !== this.completed)
                        this.$store.dispatch('checks/updateChecks', { name: 'companiaMeaReprezentantLegal', value: this.completed })
                })
            },

            clearAssociate() {
                if(!this.completed) {
                    this.form = {
                        name: '',
                        birthdate_place: '',
                        citizenship: '',
                        gender: '',
                        social_capital: '',
                        capital_contribution: '',
                        cnp: '',
                        address: '',
                        id_type: '',
                        id_series: '',
                        id_no: '',
                        phone: '',
                        email: '',
                        delegate_type: '',
                        delegate_type_name: '',
                        companies: []
                    }
                } else {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                }
            },

            addDelegateCompany() {
                if(! this.form.companies == undefined) {
                    this.form.companies = []
                }

                if(!this.completed){
                    this.form.companies.push({
                        name: '',
                        business_id: '',
                        address: '',
                        function: '',
                        percentage: '',
                        status: ''
                    })
                    this.$toast.success('Compania a fost adăugată cu succes!');
                } else {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                }

            },

            deleteDelegateCompany(key) {
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else{
                    this.form.companies.splice(key, 1)
                }
            },

            selectedAssociateChanged() {
                this.form.name = this.asociatSelectat.name
                this.form.birthdate_place = this.asociatSelectat.birthdate_place
                this.form.citizenship = this.asociatSelectat.citizenship
                this.form.gender = this.asociatSelectat.gender
                this.form.social_capital = this.asociatSelectat.social_capital
                this.form.capital_contribution = this.asociatSelectat.capital_contribution
                this.form.cnp = this.asociatSelectat.cnp
                this.form.id_type = this.asociatSelectat.id_type
                this.form.id_series = this.asociatSelectat.id_series
                this.form.id_no = this.asociatSelectat.id_no
                this.form.id_released_at = this.asociatSelectat.id_released_at
                this.form.id_released_by = this.asociatSelectat.id_released_by
                this.form.phone = ''
                this.form.email = ''
                this.form.address = ''
                this.form.delegate_type = ''
                this.form.delegate_type_name = ''
                this.form.companies = []
                let associateCompanies = this.legaturi.filter(e => e.nume === this.asociatSelectat.name).length > 0 ? this.legaturi.filter(e => e.nume === this.asociatSelectat.name)[0].legaturi : []
                if(associateCompanies !== []) {
                    let associateCompaniesOpened = associateCompanies.filter(e => e.functie)
                    associateCompaniesOpened.forEach(companie => {
                        let functie = ''
                        if(companie.functie && companie.functie === 'persoana fizica autorizata') {
                            functie = 'administrator'
                        } else if(companie.functie && companie.functie !== 'persoana fizica autorizata'){
                            functie = companie.functie
                        }
                        this.form.companies.push({
                            address: companie.judet,
                            business_id: companie.cui,
                            name: companie.firma,
                            function: functie ? functie : 'N/A',
                            percentage: companie.procentaj ? companie.procentaj + '%' : 'N/A',
                            status: companie.functiune ? 'ACTIVĂ' : 'INACTIVĂ'
                        })
                    })
                    this.$emit('associateCompanies', this.form.companies)
                }

            },
            searchCompanyAssoc(event, key) {
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    if(event.length < 7) {
                        this.$toast.error('CUI-ul introdus nu este valid.');
                    } else {
                        axios.get(api.API_ENDPOINTS.m3 + event).then(response => {
                            this.form.companies[key].name = response.data.DateGenerale.nume
                            this.form.companies[key].address = response.data.DateGenerale.adresa
                        }).catch(() => {
                            this.$toast.error('CUI-ul introdus nu este valid.');
                        })
                    }
                }

            }
        },
    }
</script>

<style scoped>
.flex-end-input >>> .form-row {
    justify-content: flex-end;
}
.form-group >>> .red-background{
    background: #f2e2e1;
}
.form-group >>> .yellow-background{
    background: rgba(253, 182, 25, 0.53);
}
.form-group >>> .green-background{
    background: #c1ece0;
}
.custom-labels >>> legend{
    max-width: 77px;
}
.min-width{
    min-width: 250px;
}
.flex{
    display: flex;
}
.align-end{
    text-align: end;
}
.alege-asociat{
    width: 60%;
}
.flex-end{
    justify-content: flex-end;
}
.adauga-asociat{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.first-input{
    width: 60%;
}
.info-text{
    font-size: 19px;
    margin: 0;
    color: #01e8c6;
    opacity: 0.7;
}
.space-between{
    justify-content: space-between;
}
.second-input{
    width: 40%;
}
.text-danger{
    white-space: pre;
}
.search-button{
    color: #fff;
    background: #49cda8;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ced4da;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    padding: 0 8px;
    cursor: pointer;
    transition: 0.4s;
}
.search-button:hover{
    background: #3bab8c;
}
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 90%;
}
.switch-box{
    text-align: right;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.form-group >>> legend{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.form-group >>> input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
.v-select >>> .vs__dropdown-menu {
    background: #e9ecef;
    max-height: 200px;
    overflow-y: hidden;
}
.v-select >>> .vs__dropdown-toggle{
    background: #e9ecef;
    margin: 0;
    border-radius: 2px;
    justify-content: space-between;
    align-items: center;
    max-height: 33px;
}
.v-select >>> .vs__actions{
    padding: 0;
}
.v-select >>> .vs__dropdown-option {
    color: #767a95;
    font-size: 13px;
    padding-left: 5px;
    font-weight: 600;
}
.v-select >>> .vs__search{
    margin: 0;
    padding: 0;
}
.v-select >>> .vs__selected{
    color: #767a95;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.inline-inputs{
    display: flex;
}
.inline-inputs input:first-child, .inline-inputs div:first-child{
    width: 25%;
    margin-right: 10px;
}
.inline-inputs div:first-child input{
    width: 100%;
}
.has-icon{
    position: relative;
}
.v-select >>> .vs__selected-options {
    flex-wrap: nowrap;
    max-width: calc(100% - 41px);
}
.v-select >>> .vs__selected {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
    margin-top: 2px;
}
.has-icon img{
    position: absolute;
    top: 10px;
    right: 20px;
    opacity: 0.3;
}
.termene-icon{
    position: absolute;
    bottom: 15px;
    left: 20px;
}
.flex-end{
    max-height: 60px;
}
.space-between{
    max-height: 60px;
}
.custom-select{
    margin-bottom: 0;
    color: #767a95;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 2px;
    font-weight: 600;
    background: #e9ecef url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
}
.disabled-select{
    background: #a1fff1 url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
}
.disabled-select >>> .vs__dropdown-toggle{
    background: #d1f5ea!important;
    color:#b2b6be!important;
    pointer-events: none;
}
.disabled-select >>> input{
    background: #d1f5ea!important;
    color:#b2b6be!important;
}
.disabled-radio{
    pointer-events: none;
}
.asociat, .companies{
    position: relative;
}
.delete-icon{
    position: absolute;
    top: 40%;
    right: -5%;
    cursor: pointer;
}
.calitate-input >>> .custom-control-inline{
    margin-right: 1.83rem;
}
.delete-delegate-company-icon {
    position: absolute;
    top: 5px;
    right: -5%;
    cursor: pointer;
}
.delete-icon:hover{
    color: red;
}
.warn p{
    margin: 0;
    font-size: 12px;
    color: #777e90;
}
.warn p:first-child{
    font-weight: 500;
    font-size: 14px;
}
.yellow-button{
    border: 1px solid #ece7da;
    background: #fff4db;
    color: #767a95;
    font-size: 12px;
    font-weight: 500;
    width: 26.2%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.select-person{
    margin-top: 15px;
}
.select-person p{
    display: flex;
    font-size: 12px;
    font-weight: 500;
    color: #777e90;
    width: 25%;
    align-items: center;
    justify-content: flex-start;
}
.select-person .v-select{
    width: 74.5%;
}
.calitate-input p{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.calitate-input >>> label{
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
    line-height: 23px;
}
.b-form-datepicker{
    color: #767a95;
    background: #e9ecef;
    font-size: 14px;
    font-weight: 700;
    padding: 0;
    max-height: 33px;
    border-radius: 2px;
}
.completed{
    background: #d1f5ea!important;
    color:#b2b6be!important;
}
.smallerLabel >>> legend{
    width: 15.2%;
    float: left;
    padding-right: 10px;
    padding-top: 0.7%!important;
}
.smallerLabel >>> div{
    width: 84.8%;
    float: left;
}
.error-input >>> span{
    color: #dc3545;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px;
    }
    .delete-delegate-company-icon{
        right: -30px;
        top: 10px;
    }
}
@media only screen and (max-width: 1441px) {
    .companies .column-res {
        display: flex;
        justify-content: space-between;
    }
    .companies .column-res .column-responsive {
        flex-direction: column;
        max-height: 100%!important;
        margin-top: 0!important;
        width: 49%;
    }
    .companies .column-res .column-responsive .form-group {
        width:100%!important;
    }
    .companies .column-res .asociati-first-input {
        width: 100%!important;
    }
    .companies .column-res .input-group .form-control {
        max-width: 100%!important;
    }
}
@media only screen and (max-width:1367px) {
  .select-person p {
    text-align: right;
    padding-right: 5px;
  }
}
@media (max-width: 1300px){
    .disabled-select >>> input{
        display: none;
    }
}
@media screen and (max-width: 1050px) {
    .b-form-datepicker {
        font-size:11px;
    }
}
</style>
